import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from 'infrastructure/common/model/api.query';
import { SortDirection } from 'infrastructure/common/model/api.sort-direction';
import { task } from 'task/model/task.fragments';
import { TaskOutput } from 'task/model/task.output';
import { TaskSortProperty } from 'task/model/task.sort-property';
import { TaskStatus } from 'task/model/task.status';

export interface FetchTasksParams {
	readonly sortProperty?: TaskSortProperty;
	readonly sortDirection?: SortDirection;
	readonly dueStartTimestamp?: number;
	readonly descriptionSearch?: string;
	readonly dueEndTimestamp?: number;
	readonly statuses?: TaskStatus[];
	readonly types?: TaskType[];
	readonly chunkSize: number;
	readonly offset: number;
}

@Injectable({ providedIn: 'root' })
export class FetchTasksApiQuery extends ApiQuery<
	TaskOutput[],
	FetchTasksParams
> {
	client = 'iam';
	document = gql`
		query FetchTasks(
			$chunkSize: Int
			$descriptionSearch: String
			$dueEndTimestamp: Long
			$dueStartTimestamp: Long
			$types: [TaskType]
			$offset: Int
			$sortDirection: Direction
			$sortProperty: TaskSort
			$statuses: [TaskStatus]
		) {
			searchTasks(
				chunkSize: $chunkSize
				descriptionSearch: $descriptionSearch
				dueEndTimestamp: $dueEndTimestamp
				dueStartTimestamp: $dueStartTimestamp
				types: $types
				offset: $offset
				sortDirection: $sortDirection
				sortProperty: $sortProperty
				statuses: $statuses
			) {
				...Task
			}
		}
		${task}
	`;
	method = 'searchTasks';
}
